/**
 * Scroll-reveal entrance animations.
 * Works with snippets/scroll-reveal.liquid:
 *  - the inline init script adds `sr-init` to <html> and arms a failsafe
 *  - sections reveal as one element each; sections containing a product grid
 *    are converted to `sr-grid` so their cards stagger in individually
 *    (the section shell itself is then never hidden)
 * Content is only ever hidden while <html> has `sr-init` and not `sr-off`,
 * so clearing either class always restores the page.
 */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('sr-init')) return;

  const MAX_STAGGER_STEPS = 6;

  const init = () => {
    const main = document.getElementById('MainContent');
    const sections = main ? [...main.querySelectorAll(':scope > .shopify-section')].slice(1) : [];
    if (!sections.length) {
      root.classList.add('sr-off');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0.01 }
    );

    for (const section of sections) {
      const cards = section.querySelectorAll('.product-card');
      if (cards.length >= 2) {
        cards.forEach((card, index) => {
          card.classList.add('sr-stagger-item');
          card.style.setProperty('--sr-i', Math.min(index, MAX_STAGGER_STEPS));
        });
        // Flag last: flips the section from whole-shell reveal to card stagger
        section.classList.add('sr-grid');
      }
      observer.observe(section);
    }

    if (window.__srFailsafe) {
      clearTimeout(window.__srFailsafe);
      window.__srFailsafe = null;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Returning from bfcache: reveal everything instantly rather than replaying.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) root.classList.add('sr-off');
  });
})();
